import { render, staticRenderFns } from "./ApprovalForm.vue?vue&type=template&id=7f4b0471&scoped=true"
import script from "./ApprovalForm.vue?vue&type=script&lang=js"
export * from "./ApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./ApprovalForm.vue?vue&type=style&index=0&id=7f4b0471&prod&scoped=true&lang=css"
import style1 from "./ApprovalForm.vue?vue&type=style&index=1&id=7f4b0471&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b0471",
  null
  
)

export default component.exports